import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import GoogleIcon from '../../../icon/GoogleIcon'

export default function ReportGeofenceCard({
  title,
  value,
  onExpand,
  subtitle = 'Visitas dentro de geocerca',
  buttonLabel = 'Ver mapa'
}) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '3px solid #E4E4E4',
        backgroundColor: '#FFFFFF',
        minHeight: 166,
        height: '100%',
        width: '100%',
        boxShadow: 'none'
      }}
    >
      <CardContent
        sx={{
          p: 2.5,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Box display="flex" alignItems="flex-start" gap={1.5}>
          <Box sx={{ color: '#597FA9', lineHeight: 0, mt: '-0.5px', flexShrink: 0 }}>
            <GoogleIcon name="distance" size={22} filled />
          </Box>

          <Box>
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 700,
                color: '#111827',
                letterSpacing: 0.2
              }}
            >
              {title}
            </Typography>

            {subtitle ? (
              <Typography
                sx={{
                  color: '#8E909B',
                  fontSize: 13,
                  ml: -4,
                  mt: 1
                }}
              >
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            gap: 1.5,
            mt: 2
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 28, md: 44 },
              lineHeight: 1.1,
              fontWeight: 800,
              color: '#4672A3'
            }}
          >
            {value}
          </Typography>

          <Button
            size="small"
            onClick={onExpand}
            endIcon={<GoogleIcon name="open_in_full" size={16} color="#111827" />}
            sx={{
              flexShrink: 0,
              textTransform: 'none',
              color: '#111827',
              borderRadius: 999,
              px: 1.5,
              py: 0.5,
              minWidth: 'auto',
              backgroundColor: '#F8FAFC',
              border: '1px solid #E5E7EB',
              '&:hover': {
                backgroundColor: '#F1F5F9'
              }
            }}
          >
            {buttonLabel}
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}
